export default __webpack_public_path__ + "static/media/integration-icon.2f996596.svg";